const YEARS = 20
const buildRangData = (start, end) => {
  const rang = []
  for (let i = start; i <= end; i++) {
    rang.push(i)
  }
  return rang.map(n => ({ text: `${n}`, value: n }))
}

export const monthData = buildRangData(1, 12)

const current = new Date()
export const currentYear = current.getFullYear()
export const currentMonth = current.getMonth() + 1
export const yearData = buildRangData(currentYear, currentYear + YEARS)
